import { AppState } from "../app.state";

export const availableStores = (state: AppState) => state?.Stores?.stores;

export const storesLoaded = (state: AppState) => state?.Stores?.isLoaded;

export const selectStorePaymentDetails = ({ storeId }) => (state: AppState) => state?.Stores?.paymentDetails?.[storeId];

export const selectStoreContactDetails = ({ storeId }) => (state: AppState) => {
    return state?.Stores?.contactDetails?.[storeId] || null;
};